import axiosInstance from '@/app/api/axiosInstance';
import { TaxComponent, TaxComponentCreate, TaxComponentUpdate } from '@/app/types/taxComponent';
import { PaginatedResponse, ListQueryParams } from '@/app/types/api';

export const listTaxComponents = async (params: ListQueryParams, organizationId?: number): Promise<PaginatedResponse<TaxComponent>> => {
  try {
    const requestParams = {
      ...params,
      ...(params.filters && typeof params.filters === 'string'
        ? { filters: params.filters }
        : organizationId
            ? { filters: JSON.stringify({ organization_id: organizationId }) }
            : {}),
       include_global: true, // Usually want org-specific + global/system components
    };
    const response = await axiosInstance.get<PaginatedResponse<TaxComponent>>('/tax-components/', {
      params: requestParams
    });
    return response.data;
  } catch (error) {
    console.error('Failed to list tax components:', error);
    throw error;
  }
};

export const getTaxComponent = async (componentId: number): Promise<TaxComponent> => {
  try {
    const response = await axiosInstance.get<TaxComponent>(`/tax-components/${componentId}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to get tax component with ID ${componentId}:`, error);
    throw error;
  }
};

export const createTaxComponent = async (data: TaxComponentCreate): Promise<TaxComponent> => {
  try {
    // Backend infers organization_id from the authenticated user
    const response = await axiosInstance.post<TaxComponent>('/tax-components/', data);
    return response.data;
  } catch (error) {
    console.error('Failed to create tax component:', error);
    throw error;
  }
};

export const updateTaxComponent = async (componentId: number, data: TaxComponentUpdate): Promise<TaxComponent> => {
  try {
    const response = await axiosInstance.patch<TaxComponent>(`/tax-components/${componentId}`, data);
    return response.data;
  } catch (error) {
    console.error(`Failed to update tax component with ID ${componentId}:`, error);
    throw error;
  }
};

export const deleteTaxComponent = async (componentId: number): Promise<void> => {
  try {
    await axiosInstance.delete(`/tax-components/${componentId}`);
  } catch (error) {
    console.error(`Failed to delete tax component with ID ${componentId}:`, error);
    throw error;
  }
}; 